import { Link } from 'react-router-dom'
import AlertList from '../alerts/AlertList'
import AlertDetail from '../alerts/AlertDetail'
import HazardFilter from '../filters/HazardFilter'
import SeverityFilter from '../filters/SeverityFilter'
import RegionFilter from '../filters/RegionFilter'
import { useAlertStore } from '../../store/alertStore'
import { useAuthStore } from '../../store/authStore'
import { useAuth } from '../../hooks/useAuth'
import { useSettingsStore } from '../../store/settingsStore'
import PushNotificationButton from '../PushNotificationButton'

export default function Sidebar() {
  const selectedId = useAlertStore((s) => s.selectedAlertId)
  const username = useAuthStore((s) => s.username)
  const { logout, isAdmin } = useAuth()
  const { theme, toggleTheme } = useSettingsStore()

  return (
    <aside className="flex flex-col h-full bg-gray-50 dark:bg-gray-950 border-r border-gray-200 dark:border-gray-800 w-80 xl:w-96 shrink-0">
      {/* Top bar */}
      <div className="flex items-center justify-between px-3 py-2.5 border-b border-gray-200 dark:border-gray-800 shrink-0">
        <div className="flex items-center gap-2">
          <svg viewBox="0 0 32 32" className="w-6 h-6 shrink-0">
            <path d="M16 4 L30 28 L2 28 Z" fill="none" stroke="#E85D24" strokeWidth="2.5" strokeLinejoin="round"/>
            <line x1="16" y1="13" x2="16" y2="21" stroke="#E85D24" strokeWidth="2.5" strokeLinecap="round"/>
            <circle cx="16" cy="24.5" r="1.5" fill="#E85D24"/>
          </svg>
          <span className="text-sm font-semibold text-gray-900 dark:text-gray-100">CAP Alerts</span>
        </div>
        <div className="flex items-center gap-2">
          {username && (
            <span className="text-xs text-gray-500 truncate max-w-[80px]" title={username}>
              {username}
            </span>
          )}
          {isAdmin && (
            <Link
              to="/admin"
              title="Administration"
              className="text-gray-500 hover:text-gray-700 dark:text-gray-600 dark:hover:text-gray-300 transition-colors"
            >
              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
            </Link>
          )}
          <PushNotificationButton />
          <button
            type="button"
            onClick={toggleTheme}
            title={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
            className="text-gray-500 hover:text-gray-700 dark:text-gray-600 dark:hover:text-gray-300 transition-colors"
          >
            {theme === 'dark' ? (
              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8}>
                <circle cx="12" cy="12" r="4"/><path strokeLinecap="round" d="M12 2v2M12 20v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M2 12h2M20 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/>
              </svg>
            ) : (
              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8}>
                <path strokeLinecap="round" d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z"/>
              </svg>
            )}
          </button>
          <button
            type="button"
            onClick={logout}
            className="text-xs text-gray-500 hover:text-gray-700 dark:text-gray-600 dark:hover:text-gray-400 transition-colors"
          >
            Sign out
          </button>
        </div>
      </div>

      {/* Filters */}
      <div className="border-b border-gray-200 dark:border-gray-800 shrink-0">
        <RegionFilter />
        <HazardFilter />
        <SeverityFilter />
      </div>

      {/* Content: list or detail */}
      <div className="flex-1 overflow-hidden">
        {selectedId ? <AlertDetail /> : <AlertList />}
      </div>
    </aside>
  )
}
